import { useState } from 'react';
import { CheckCircle2, Search } from 'lucide-react';
import { PlaceAutocomplete, type ResolvedAddress } from '@/components/ui/PlaceAutocomplete';
import form from '@/components/ui/Form.module.css';
import styles from './HostCampaignPage.module.css';

const emptyAddress = () => ({ street: '', city: '', state: '', zip: '', country: '' });
const hasAddressSearch = Boolean(import.meta.env['VITE_GOOGLE_MAPS_KEY']);

export function HostLocationFields() {
  const [address, setAddress] = useState(emptyAddress);
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(false);
  function select(result: ResolvedAddress) {
    setSearch(result.formatted_address || result.street);
    setAddress({ street: result.street, city: result.city, state: result.state, zip: result.zip,
      country: ['US', 'CA'].includes(result.country) ? result.country : '' });
    setSelected(true);
  }
  return <>
    <div className={styles.fields}>
      <label className={styles.field}>Legal organization paying the utility bill
        <input className={form.input} name="organization" autoComplete="organization" required maxLength={160} placeholder="Organization or property owner" />
      </label>
      <label className={styles.field}>Location name
        <input className={form.input} name="site_name" required maxLength={160} placeholder="For example, Riverside Business Centre" />
      </label>
    </div>
    {hasAddressSearch && <div className={styles.addressSearch}>
      <label htmlFor="host-address-search" className={styles.searchLabel}><Search size={17} aria-hidden="true" /> Find your address</label>
      <PlaceAutocomplete id="host-address-search" value={search} placeholder="Start typing the street address"
        onTextChange={text => { setSearch(text); setSelected(false); setAddress(emptyAddress()); }} onSelect={select} />
      <p className={styles.hint}>Choose a suggestion to fill in the address, or enter the details below.</p>
      {selected && <p className={styles.addressConfirmed} role="status"><CheckCircle2 size={17} aria-hidden="true" /> Address filled. Please check the details below.</p>}
    </div>}
    <label className={styles.field}>Street address
      <input className={form.input} name="street" autoComplete="address-line1" required maxLength={200}
        value={address.street} onChange={e => setAddress(a => ({ ...a, street: e.target.value }))} />
    </label>
    <div className={styles.fields}>
      <label className={styles.field}>City
        <input className={form.input} name="city" autoComplete="address-level2" required maxLength={100}
          value={address.city} onChange={e => setAddress(a => ({ ...a, city: e.target.value }))} />
      </label>
      <label className={styles.field}>State or province
        <input className={form.input} name="state" autoComplete="address-level1" required maxLength={100}
          value={address.state} onChange={e => setAddress(a => ({ ...a, state: e.target.value }))} />
      </label>
      <label className={styles.field}>ZIP or postal code
        <input className={form.input} name="zip" autoComplete="postal-code" required maxLength={20}
          value={address.zip} onChange={e => setAddress(a => ({ ...a, zip: e.target.value }))} />
      </label>
      <label className={styles.field}>Country
        <select className={form.select} required name="country" autoComplete="country" value={address.country}
          onChange={e => setAddress(a => ({ ...a, country: e.target.value }))}>
          <option disabled value="">Select country</option><option value="US">United States</option><option value="CA">Canada</option>
        </select>
      </label>
    </div>
    <label className={styles.field}>Site type
      <select className={form.select} name="site_type"><option value="commercial">Commercial</option><option value="multifamily">Multifamily building</option><option value="public">Public site</option></select>
    </label>
  </>;
}
